import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import FoodcompositionEditFormImpl from './FoodcompositionEditFormImpl';
import FoodcompositionList from './FoodcompositionList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import FoodcompositionListView from './FoodcompositionListView'


export default function FoodcompositionDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.foodcompositionDashboard);
  const [ foodcompositionId, setFoodcompositionId] = React.useState('');
  const [reloadFoodcompositionList, setReloadFoodcompositionList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <FoodcompositionEditFormImpl 
            setReloadFoodcompositionList={setReloadFoodcompositionList}
            foodcompositionId={foodcompositionId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <FoodcompositionListView 
                      setFoodcompositionId = {setFoodcompositionId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
